var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kt-heading kt-heading--md"},[_c('span',{staticClass:"kt-badge kt-badge--brand kt-badge--lg"},[_vm._v(_vm._s(_vm.actual.numero))]),_vm._v("\n    "+_vm._s(_vm.actual.titulo)+"\n    "),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }